import { SpherePlatformApp } from '@sphere/platform';
import { PATHS } from './user-manager.paths';
import { administrationApp } from './administration';

export const AdministrationApp: SpherePlatformApp = {
    APP: administrationApp,
    PATHS
};
